/*
 ************************************************************************
 *  © [2015 - 2023] Quintype Technologies India Private Limited
 *  All Rights Reserved.
 *************************************************************************
 */

import * as React from "react";
import { t } from "i18n";
import { get } from "lodash";

import TextField from "components/text-field/text-field";
import { WruConfig, Integrations } from "api/integrations";
import { isClientValidationError } from "utils/validation.utils";

interface Props {
  integration: { key: Integrations.Wru; value: WruConfig };
  updateIntegrationField: (key: string, value: Object) => void;
  readOnly?: boolean;
  errors: Error | null;
}

const Wru: React.SFC<Props> = ({ integration, updateIntegrationField, readOnly, errors }) => {
  const integrationName = integration.key;
  return (
    <React.Fragment>
      <TextField
        label={t("integrations.fields.mid")}
        value={integration.value["mid"]}
        onChange={(value) => updateIntegrationField(integrationName, { mid: value })}
        readOnly={readOnly}
        errorMessage={
          isClientValidationError<WruConfig>(errors) ? get(errors, ["errors", "value", "mid", "0"]) : undefined
        }
      />
    </React.Fragment>
  );
};

export default Wru;
